// skills/cooking/index.js
// Cooking skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderCookingUI,
    updateCookingUI,
    initCookingUI,
    toggleCooking,
    upgradeTool,
    toggleEmpowering,
    switchCookingTab
} from './cookingUI.js';

/**
 * Cooking skill configuration
 */
const cookingConfig = {
    id: 'cooking',
    name: 'Cooking',
    icon: '🍳',
    iconImage: 'assets/icons/skill_icons/cooking.png',
    description: 'Cook raw food for better healing',

    tabs: [
        { id: 'food', name: 'Food', default: true },
    ],

    render(params = {}) {
        renderCookingUI();
    },

    update() {
        updateCookingUI();
    },

    init() {
        initCookingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('cooking', cookingConfig);

if (typeof window !== 'undefined') {
    window.cookingUI = {
        toggleCooking,
        upgradeTool,
        toggleEmpowering,
        switchCookingTab
    };
}

export default cookingConfig;
